import Vue from 'vue';
export const EventBus = new Vue({
    data: {
        modelIndex: null    // 产品中心轮播的当前产品index
    },
    methods: {
        changeModelIndex: function (index) {
          console.log('changeModelIndex: , ', index)
          this.modelIndex =  index
        }
    }
});


// WEBPACK FOOTER //
// ./src/common/js/event-bus.js